module.exports = __webpack_public_path__ + "img/teach_banner.a064bedf.jpg";